import { HostBinding, Component, ElementRef, Renderer2, Input } from '@angular/core';
import { BootstrapColor } from '../../global-types';

@Component({
  selector: 'bp-progress, bp-prg',
  exportAs: 'bpProgress',
  template: `<ng-content></ng-content>`
})
export class BpProgressComponent {
  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.addClass(this.el.nativeElement, 'progress');
  }
}

@Component({
  selector: 'bp-progress-bar, bp-prg-bar',
  exportAs: 'bpProgressBar',
  template: `<ng-content></ng-content>`
})
export class BpProgressBarComponent {
  private minValue = 0;
  private maxValue = 100;
  private val = 0;

  @Input() color: BootstrapColor;
  @Input() striped = false;
  @Input() animated = false;

  @HostBinding('class') public get _class() {
    let cls = 'progress-bar';
    if (this.color) {
      cls += ` bg-${this.color}`;
    }
    if (this.animated) {
      cls += ' progress-bar-animated';
    }
    if (this.striped) {
      cls += ' progress-bar-striped';
    }

    return cls;
  }

  @Input() set min(value) {
    if (!Number.isFinite(value)) {
      throw Error(`invalid min value for bp-progress-bar.`);
    }

    this.minValue = value;
  }

  get min() {
    return this.minValue;
  }

  @Input() set max(value) {
    if (!Number.isFinite(value)) {
      throw Error(`invalid max value for bp-progress-bar.`);
    }

    this.maxValue = value;
  }

  get max() {
    return this.maxValue;
  }

  @Input() set value(value) {
    if (!Number.isFinite(value)) {
      throw Error(`invalid value for "value" property of bp-progress-bar.`);
    }

    this.val = value;
  }

  get value() {
    return this.val;
  }

  @HostBinding('style.width') get _width() {
    let percentage;
    if (this.val <= this.minValue || this.minValue > this.maxValue) {
      percentage = 0;
    } else if (this.val >= this.maxValue) {
      percentage = 100;
    } else {
      percentage = ((this.val - this.minValue) / (this.maxValue - this.minValue)) * 100;
    }

    return percentage.toFixed() + '%';
  }

  constructor(private el: ElementRef, private renderer: Renderer2) {
    this.renderer.setAttribute(this.el.nativeElement, 'role', 'progressbar');
  }
}
